import { useState } from "react";
import { useI18n } from "../../i18n/I18nProvider";
import { Button } from "./Button";

/** Read-only value with a Copy button. Used for one-time secrets such as links and keys. */
export function CopyField({ value }: { value: string }) {
  const { t } = useI18n();
  const [copied, setCopied] = useState(false);
  const [failed, setFailed] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setFailed(false);
    } catch {
      setFailed(true);
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <input
        readOnly
        value={value}
        aria-label={value}
        onFocus={(event) => event.target.select()}
        className="h-11 min-w-0 flex-1 tabular text-note"
      />
      <Button variant="primary" onClick={() => void copy()}>
        {copied ? t("common.copied") : t("common.copy")}
      </Button>
      {failed ? (
        <span role="alert" className="basis-full text-xs text-red">
          {t("link.shareUnsupported")}
        </span>
      ) : null}
    </div>
  );
}
